import React, { Component } from 'react';
import { connect } from "react-redux"
import _ from 'lodash';
import agent from '../agent'
import { Field, reduxForm, FormSection } from 'redux-form';
import ArtistPhoto from './ArtistPhoto'
import SelectComponent from './ui/SelectComponent'
import ArrayCheckbox from "./ArrayCheckbox";
import NewAgency from './NewAgency';
import classNames from 'classnames';
import AMLogo from '../assets/images/Default Agency Logo.png';
import moment from 'moment'

const renderSearchAgency = ({ input, className, placeholder, type, meta: { touched, error } }) => (
  	<div>
		<input {...input} placeholder={placeholder} type={type} />
		{ (touched && error) && <span className="form-error is-visible" id="uuid">{error}</span> }
	</div>
)

class BasicInfoBottom extends Component {
	state = {
		enableEdit: false,
		showAgency: false,
		isNewAgency: false
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.showModal_info)
			this.setState({ enableEdit: !nextProps.showModal_info })
	}

	searchAgency = _.debounce( event => {
		if (this.state.isNewAgency)
			this.setState({ isNewAgency: !this.state.isNewAgency })
		if (event.target.value.length < 3) { return false }
		this.props.searchAgency(event.target.value, 'US');
	}, 1000)

	editRepresentation = () => {
		this.setState({ enableEdit: this.state.enableEdit ? false : true })
	}

	newAgency = (e) => {
		this.setState({isNewAgency: true});
	}

	onChangeRepresentation = (stateType, event, newValue) => {
		this.setState({ showAgency: newValue === 'represented' })
    }

    componentWillMount() {
    	const project1 = agent.Project.getPubRegProj(this.props.artistInfo.id)
    	const project2 = agent.Project.getCheckinProj(this.props.artistInfo.id)
    	//const audition = agent.Project.auditionEventById(this.props.artistInfo.audition_ids[0])	//14350 //13966 //13963
        this.props.loadProjects(
            Promise.all([
                project1,
                project2
            ])
        )
    }

	render() {
		const { handleSubmit, pristine, submitting, error, fieldDisabled, artistPhoto, projectId, 
			initialValues, agencies = [], showModal_info, artistInfo } = this.props
		var creator = ''
		if (this.props.projects && this.props.projects.length != 0) {
			var firstProjId = artistInfo.project_ids_joined.sort(function(a,b) { return a-b })[0]
			creator = artistInfo.creator_company != null ? artistInfo.creator_company : 'Yourself (Talent)'
			var project = this.props.projects.find(k => k.id === firstProjId)
			var name = project ? project.name : 'No Project'
			creator = creator + ', ' + name
			creator = creator + ', ' + (project ? moment(project.created_at).format('MMMM YYYY') : '')
		} else {
			creator = artistInfo.creator_company != null ? (artistInfo.creator_company.name ? artistInfo.creator_company.name : artistInfo.creator_company) : 'Yourself (Talent)'
			//creator = creator + ', ' + 'No Project'
		}
		return (
			<div id="basic-info-bottom-details" className="row">
				<div className="column">
					<div className="grid-x medium-7">
						<i className="cell medium-1 small-2 fa fa-star-o" aria-hidden="true"></i>
						<p className="cell medium-6 small-9">Member Since: {moment(artistInfo.created_at).format('MMMM YYYY')}</p>
					</div>
					<div className="grid-x medium-7">
						<i className="cell medium-1 small-2 fa fa-user-circle-o" aria-hidden="true"></i>
						<p className="cell medium-11 small-9">Profile Created by: {creator}</p>
					</div>
					<div className="grid-x medium-7">
						<i className="cell medium-1 small-2 fa fa-question-circle-o" aria-hidden="true"></i>
						<p className="cell medium-11 small-9">Last Update to Profile: {moment(artistInfo.updated_at).format('Do MMMM YYYY ha zz')}</p>
					</div>
					<div className="grid-x medium-7">
						<i className="cell medium-1 small-2 fa fa-sticky-note-o" aria-hidden="true"></i>
						<p className="cell medium-11 small-9">Basic Profile Includes: 1 Representation, 1 Primary Image, Statistics, Resume credits, 20 x Skills</p>
					</div>
				</div>
			</div>)
	}
}


BasicInfoBottom = reduxForm({
	form: 'ArtistBasicInfo', // <------ same form name
  // destroyOnUnmount: false, // <------ preserve form data
  // forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(BasicInfoBottom)

const mapStateToProps = state => ({
  initialValues: {
    artist: {
      first_name: state.common.artistInfo ? state.common.artistInfo.first_name : '',
      last_name: state.common.artistInfo ? state.common.artistInfo.last_name : '',
      mobile_number: state.common.artistInfo ? state.common.artistInfo.mobile_number : '',
      at2_agency_name: state.common.artistInfo ? state.common.artistInfo.at2_agency_name : '',
      email: state.common.artistInfo ? state.common.artistInfo.email : '',
      category: state.common.artistInfo ? state.common.artistInfo.category : '',
      agencies: state.common.artistInfo ? state.common.artistInfo.agencies : []
    }
  },
  agencies: state.artist ? state.artist.agencies : [],
  projects: state.projects.projects ? state.projects.projects : null
});

const mapDispatchToProps = dispatch => ({
	searchAgency: (search, country) => 
  		dispatch({ type: 'SEARCH_AGENCY', payload: agent.Agency.search(search, country) }),
  	loadProjects: payload => 
  		dispatch({ type: 'DASHBOARD_LOAD_PROJ', payload: payload })
});

export default connect(mapStateToProps, mapDispatchToProps)(BasicInfoBottom);



// WEBPACK FOOTER //
// ./src/components/BasicInfoBottom.js